import {
  BUSINESS_OPPORTUNITY_CONSTR_PROJECT,
  OLD_USER_CENTER_URL,
  SEARCH_PAGE_URL,
  USER_APPLICATION_ADD_TENDER_URL,
  SUBSCRIPTION_CENTER_SETTING_URL,
  USER_APPLICATION_BUSINESS_ANALYSIS_URL,
  USER_APPLICATION_CONNECTIONS_URL,
  TKB_URL,
  REN_MAI_URL,
  QDB_URL,
  DATA_MALL_URL,
  DATA_CUSTOMIZATION_SERVICE_URL,
} from "./constants";
import { OID_MAP } from "./constants.track";

export const ConstantsProductServicesData = [
  {
    id: "1",
    name: "商机服务",
    describe:
      '累计<span class="bold">2.2亿</span> 招投标信息，每天 <span class="bold">25万+ </span>招投标资讯更新，微信、浏览器、APP，全平台服务支持',
  },
  {
    id: "2",
    name: "标讯发布",
    describe: '专注招投标信息服务 ，众多<span class="bold">500强</span>企业信赖的招投标资讯平台',
  },
  { id: "3", name: "更多服务", describe: "拓展企业人脉，赢得更多商机，更有多种定制化服务等您垂询" },
];
export const ProductsServicesChildData = {
  1: [
    {
      id: "1-1",
      icon: require("../../assets/img/product-services-content/ProductsServices1_1.png"),
      name: "招标查询",
      describe: "查预告 查招标 查中标",
      oid: OID_MAP.PRODUCTS_SERVICES_BILLBOARD_CLICK,
      tipLIst: [
        "实时标讯更新，数据覆盖更全面",
        "多种筛选方式，业务数据查询更方便",
        "支持标题、正文、附件搜索，精准锁定商机",
      ],
      goToUrl: SEARCH_PAGE_URL,
    },
    {
      id: "1-2",
      icon: require("../../assets/img/product-services-content/ProductsServices1_2.png"),
      name: "VIP项目",
      describe: "千里马项目信息",
      oid: OID_MAP.PRODUCTS_SERVICES_VIP_CLICK,
      tipLIst: ["千里马信息渠道，高级会员尊享", "项目信息全程跟踪，动态实时掌控", "更有项目专盯、专属客服跟进服务"],
      goToUrl: OLD_USER_CENTER_URL,
    },
    {
      id: "1-3",
      icon: require("../../assets/img/product-services-content/ProductsServices1_3.png"),
      name: "拟在建项目查询",
      describe: "正在报批、立项中的项目",
      oid: OID_MAP.PRODUCTS_SERVICES_PROJECT_CLICK,
      tipLIst: ["提前3-12个月查看项目信息", "正在报批、立项、审核中的项目", "包含业主单位、设计单位负责人信息"],
      goToUrl: BUSINESS_OPPORTUNITY_CONSTR_PROJECT,
    },
    {
      id: "1-4",
      icon: require("../../assets/img/product-services-content/ProductsServices1_4.png"),
      name: "商机推送",
      describe: "微信、邮件实时接收最新动态",
      oid: OID_MAP.PRODUCTS_SERVICES_BUSINESS_OPPORTUNITY_PUSH_CLICK,
      tipLIst: ["第一时间掌控市场商机变化", "微信、邮件多渠道推送提醒", "将商机信息随时分享给部门同事"],
      goToUrl: SUBSCRIPTION_CENTER_SETTING_URL,
    },
    {
      id: "1-5",
      icon: require("../../assets/img/product-services-content/ProductsServices1_5.png"),
      name: "企业智能管理",
      describe: "业务统一管理、商机自动分配",
      oid: OID_MAP.PRODUCTS_SERVICES_ENTERPRISE_INTELLIGENT_MANAGEMENT_CLICK,
      tipLIst: ["销售线索统一管理、分配", "按需配置账号地区、订阅权限", "提升企业销售人员管理能力"],
      goToUrl: OLD_USER_CENTER_URL,
    },
    {
      id: "1-6",
      icon: require("../../assets/img/product-services-content/ProductsServices1_6.png"),
      name: "企业商情分析",
      describe: "潜在客户、竞争对手历史数据分析",
      oid: OID_MAP.PRODUCTS_SERVICES_COMPANY_ANALYSE_RIGHT_CLICK,
      tipLIst: ["深入挖掘企业关系网络", "洞察历史招投标数据信息", "助力企业招投标业务决策"],
      goToUrl: USER_APPLICATION_BUSINESS_ANALYSIS_URL,
    },
  ],
  2: [
    {
      id: "2-1",
      icon: require("../../assets/img/product-services-content/ProductsServices2_1.png"),
      name: "发布招标信息",
      describe: "发布招标、采购信息",
      oid: OID_MAP.PRODUCTS_SERVICES_PUBLISH_BIDDING_CLICK,
      tipLIst: ["精准对接招投标企业", "广为人知的招投标平台", "专属客服跟进服务"],
      goToUrl: USER_APPLICATION_ADD_TENDER_URL,
    },
    {
      id: "2-2",
      icon: require("../../assets/img/product-services-content/ProductsServices2_2.png"),
      name: "推荐招标专区",
      describe: "专属招标专区，提升信息曝光量",
      oid: OID_MAP.PRODUCTS_SERVICES_RECOMMEND_BIDDING_CLICK,
      tipLIst: ["知名企业独享招标专区", "汇总完整的招投标数据", "立即提升招标信息曝光量"],
      goToUrl: OLD_USER_CENTER_URL,
    },
  ],
  3: [
    {
      id: "3-1",
      icon: require("../../assets/img/product-services-content/ProductsServices3_1.png"),
      name: "找人脉",
      describe: "专业团队精确定位项目联系人",
      oid: OID_MAP.PRODUCTS_SERVICES_FINDING_CONNECTIONS_CLICK,
      tipLIst: ["1对1客服为您提供专业服务", "帮助企业打通关键人脉", "为您提供触达客户的最优路径"],
      goToUrl: USER_APPLICATION_CONNECTIONS_URL,
    },
    {
      id: "3-2",
      icon: require("../../assets/img/product-services-content/ProductsServices3_2.png"),
      name: "拓客宝",
      describe: "定位优质潜客资源",
      oid: OID_MAP.PRODUCTS_SERVICES_TUO_KE_BAO_CLICK,
      tipLIst: ["根据产品词、品牌名找客户 ", "快速定位客户资源", "帮您筛选潜客资源"],
      goToUrl: TKB_URL,
    },
    {
      id: "3-3",
      icon: require("../../assets/img/product-services-content/ProductsServices3_3.png"),
      name: "人脉通",
      describe: "拓展您的人脉资源",
      oid: OID_MAP.PRODUCTS_SERVICES_REN_MAI_TONG_CLICK,
      tipLIst: ["拓展更多人脉", "实时监控人脉商机", "潜在竞争对手分析"],
      goToUrl: REN_MAI_URL,
    },
    {
      id: "3-4",
      icon: require("../../assets/img/product-services-content/ProductsServices3_4.png"),
      name: "渠道宝",
      describe: "AI大数据帮您高效拓展渠道",
      oid: OID_MAP.PRODUCTS_SERVICES_QU_DAO_BAO_CLICK,
      tipLIst: ["根据产品词、公司名拓渠道", "高效定位相关企业", "大数据支撑智能决策"],
      goToUrl: QDB_URL,
    },
    {
      id: "3-5",
      icon: require("../../assets/img/product-services-content/ProductsServices3_5.png"),
      name: "数据商城",
      describe: "分行业商机分析、供应商筛选",
      oid: OID_MAP.PRODUCTS_SERVICES_DATA_MALL_CLICK,
      tipLIst: ["超10年招中标数据下载", "支持分行业、地区定制", "帮助企业决策，助力业务增长"],
      goToUrl: DATA_MALL_URL,
    },
    {
      id: "3-6",
      icon: require("../../assets/img/product-services-content/ProductsServices3_6.png"),
      name: "数据定制",
      describe: "数据维度定制、BI、API定制等",
      oid: OID_MAP.PRODUCTS_SERVICES_DATA_CUSTOMIZED_CLICK,
      tipLIst: ["更全面、准确的把握市场数据", "评估销售结果，感知市场动态", "支持数据维度、BI、API定制及CRM接入"],
      goToUrl: DATA_CUSTOMIZATION_SERVICE_URL,
    },
  ],
};
